import { z } from 'zod';
export const logtoUiCookieGuard = z
    .object({ appId: z.string(), organizationId: z.string(), uiLocales: z.string() })
    .partial();
